<template>
  <div class="checkin-pc" :style="`background:${bgcolor}`">
    <div class="search-area">
      <van-search
        v-model="keyword"
        :placeholder="placeholder"
        background="rgba(255,255,255,0)"
        shape="round"
        @search="onSearch"
      ></van-search>
      <div class="error">
        <transition name="fade">
          <div v-if="error">{{error}}</div>
        </transition>
      </div>
      <div @click="onSearch" class="button">搜索</div>
    </div>
  </div>
</template>

<script>
import { getCheckinConfig, searchCheckin } from "../../libs/api";

export default {
  data() {
    return {
      keyword: "",
      error: "",
      bgcolor: "f4f4f4",
      loading: false,
      placeholder: "输入关键词搜索"
    };
  },
  mounted() {
    this.get_checkin_config();
  },
  methods: {
    get_checkin_config() {
      getCheckinConfig({ checkinid: this.$route.query.checkinid }).then(r => {
        if (r.data.configname) {
          document.title = r.data.configname;
        }
        this.placeholder = r.data.placeholder;
        if (r.data.backgroundimage) {
          this.bgcolor = `url(${r.data.backgroundimage}) no-repeat center center/100% 100%`;
        } else {
          if (r.data.backgroundcolor) {
            this.bgcolor = `#${r.data.backgroundcolor}`;
          } else {
            this.bgcolor = "#f4f4f4";
          }
        }
      });
    },
    onSearch() {
      this.loading = true;
      if (!this.keyword) {
        this.loading = false;
        this.list = [];
        return;
      }
      searchCheckin({
        keywords: this.keyword,
        checkinid: this.$route.query.checkinid
      }).then(r => {
        this.loading = false;
        if (r.data.length == 0) {
          this.error = "未找到选手";
          setTimeout(() => {
            this.error = "";
          }, 2000);
          return;
        } else {
          this.error = "";
        }
        this.$router.push({
          name: "checkinpcdetail",
          params: {
            id: r.data[0].id
          },
          query: {
            checkinid: this.$route.query.checkinid
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fade-enter-active {
  animation: fade-in 0.5s;
}
.fade-leave-active {
  transition: all 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes fade-in {
  0% {
    opacity: 0.5;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.checkin-pc {
  display: flex;
  width: 100vw;
  height: 100vh;
  background: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center center;
  .error {
    margin-top: -8px;
    margin-bottom: 10px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(221, 51, 51);
  }
  .search-area {
    margin-top: 2rem;
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  .button {
    align-self: center;
    margin-top: 0.2rem;
    display: inline-block;
    font-size: 0.6rem;
    color: #393940;
    background: #ffffff96;
    padding: 0.2rem 2rem;
    border-radius: 0.2rem;
    transition: all 0.2s;
    &:active {
      transition: all 0.2s;
      background: #ffffff;
    }
  }
}
</style>
